// Collection page — browse every crew, edict, and deck mod in the game.
// Pure reference; no per-user state. Helps a captain plan a build before
// hitting the Port.
import { api } from '../api/client';
let unmounted = false;
export function unmountCollection() { unmounted = true; }
export async function renderCollection(root, goToLobby) {
    unmounted = false;
    root.innerHTML = `
    <div class="page collection-page">
      <header class="page-header">
        <button class="btn btn--ghost btn--icon" id="btn-back-lobby" title="Back to lobby">←</button>
        <h1 class="page-title">Collection</h1>
      </header>
      <div class="collection-loading">Loading…</div>
    </div>`;
    root.querySelector('#btn-back-lobby')?.addEventListener('click', goToLobby);
    let data;
    try {
        data = await api.collection();
    }
    catch (err) {
        root.querySelector('.collection-loading').textContent = `Failed to load: ${err.message}`;
        return;
    }
    if (unmounted)
        return;
    const page = root.querySelector('.collection-page');
    page.innerHTML = `
    <header class="page-header">
      <button class="btn btn--ghost btn--icon" id="btn-back-lobby" title="Back to lobby">←</button>
      <h1 class="page-title">Collection</h1>
      <div class="profile-greet">${data.crew.length} crew · ${data.edicts.length} edicts · ${data.deck_mods.length} mods</div>
    </header>
    <p class="profile-blurb">Every card in the pool. Browse here to plan a build before you visit the Port.</p>

    <div class="collection-tabs">
      <button class="tab-btn tab-btn--active" data-tab="crew">Crew (${data.crew.length})</button>
      <button class="tab-btn" data-tab="edicts">Edicts (${data.edicts.length})</button>
      <button class="tab-btn" data-tab="mods">Deck mods (${data.deck_mods.length})</button>
    </div>

    <section class="collection-section" data-section="crew">
      ${groupByArchetype(data.crew).map(([arch, crew]) => `
        <h2 class="collection-archetype">${escape(prettyArch(arch))}</h2>
        <div class="collection-grid">
          ${crew.map(crewCard).join('')}
        </div>
      `).join('')}
    </section>

    <section class="collection-section" data-section="edicts" style="display:none">
      <div class="collection-grid">
        ${data.edicts.map(edictCard).join('')}
      </div>
    </section>

    <section class="collection-section" data-section="mods" style="display:none">
      <div class="collection-grid">
        ${data.deck_mods.map(modCard).join('')}
      </div>
    </section>
  `;
    page.querySelector('#btn-back-lobby')?.addEventListener('click', goToLobby);
    // Tab switching.
    page.querySelectorAll('.tab-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
            page.querySelectorAll('.tab-btn').forEach((b) => b.classList.remove('tab-btn--active'));
            btn.classList.add('tab-btn--active');
            const want = btn.dataset.tab;
            page.querySelectorAll('.collection-section').forEach((s) => {
                s.style.display = s.dataset.section === want ? '' : 'none';
            });
        });
    });
}
function crewCard(c) {
    return `
    <div class="collection-card collection-card--crew">
      <div class="collection-card-head">
        <strong>${escape(c.name)}</strong>
        <span class="collection-card-cost">🪙${c.cost}</span>
      </div>
      <div class="collection-card-arch">${escape(prettyArch(c.archetype))}</div>
      <p class="collection-card-desc">${escape(c.description)}</p>
      <em class="collection-card-flavor">${escape(c.flavor)}</em>
    </div>`;
}
function edictCard(e) {
    return `
    <div class="collection-card collection-card--edict">
      <div class="collection-card-head">
        <strong>${escape(e.name)}</strong>
        <span class="collection-card-cost">🪙${e.cost}</span>
      </div>
      <p class="collection-card-desc">${escape(e.description)}</p>
    </div>`;
}
function modCard(m) {
    return `
    <div class="collection-card collection-card--mod">
      <div class="collection-card-head">
        <strong>${escape(m.name)}</strong>
        <span class="collection-card-cost">🪙${m.cost}</span>
      </div>
      <p class="collection-card-desc">${escape(m.description)}</p>
    </div>`;
}
function groupByArchetype(crew) {
    const map = new Map();
    for (const c of crew) {
        const arch = c.archetype || 'misc';
        if (!map.has(arch))
            map.set(arch, []);
        map.get(arch).push(c);
    }
    // Stable order: earner, boarder, modifier, disruptor, comeback, then alpha.
    const order = ['earner', 'boarder', 'modifier', 'disruptor', 'comeback'];
    return [...map.entries()].sort(([a], [b]) => {
        const ai = order.indexOf(a);
        const bi = order.indexOf(b);
        if (ai !== -1 && bi !== -1)
            return ai - bi;
        if (ai !== -1)
            return -1;
        if (bi !== -1)
            return 1;
        return a.localeCompare(b);
    });
}
function prettyArch(s) {
    return s.split('_').map((w) => w[0].toUpperCase() + w.slice(1)).join(' ');
}
function escape(s) {
    return s.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}
